import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NavigationStateService {
  private riskAnalysisDisabledSubject = new BehaviorSubject<boolean>(false);
  public riskAnalysisDisabled$ = this.riskAnalysisDisabledSubject.asObservable();

  constructor() { }

  disableRiskAnalysis() {
    this.riskAnalysisDisabledSubject.next(true);
  }

  enableRiskAnalysis() {
    this.riskAnalysisDisabledSubject.next(false);
  }

  isRiskAnalysisDisabled(): boolean {
    return this.riskAnalysisDisabledSubject.value;
  }
}
